import React from 'react'
import * as S from './Footer.styled'
import Link from 'next/link'
import { useShipment } from '@entities/shipment/model'
import { useCityById } from '@entities/cities/hooks'
import { useOpenStockSelectorWithBasketItems } from 'src/features/shipment-selector/hooks'

const Footer = () => {
    const shipment = useShipment()
    const city = useCityById(shipment.cityId || 1)
    const openStockSelectorWithBasketItems = useOpenStockSelectorWithBasketItems()
    return (
        <S.Footer>
            <S.NavBlock>
                {' '}
                <S.feedbackContainer>
                    <S.PhoneContainer>
                        <S.Phone
                            href={`tel:${((city ? city.phone : false) || '+7 (495) 363-3500').replace(/\D+/g, '')}`}>
                            {' '}
                            {(city ? city.phone : false) || '+7 (495) 363-3500'}
                        </S.Phone>
                        <S.PhoneTime>07:00-23:00</S.PhoneTime>
                    </S.PhoneContainer>
                    <S.SocityBlock>
                        {/*<S.SocityIconImage src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/InstaFrame.svg`} />
                        <S.SocityIconImage src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/FaceBookFrame.svg`} />*/}
                        <S.SocityIconImage src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/VKFrame.svg`} />
                        <S.SocityIconImage
                            src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/WhatsAppFrame.svg`}
                        />
                        <S.SocityIconImage
                            src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/YouTubeFrame.svg`}
                        />
                        <S.SocityIconImage src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/OKFrame.svg`} />
                    </S.SocityBlock>
                    <S.AppsBlock>
                        <S.AppLink href="https://play.google.com/store/apps/details?id=ru.zdorov" target="_blank">
                            <S.AppIconImage
                                src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/GooglePlayBtn.svg`}
                            />
                        </S.AppLink>
                        <S.AppLink href="https://appsto.re/ru/nftOkb.i" target="_blank">
                            <S.AppIconImage
                                src={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/assets/logo/AppleStoreBtn.svg`}
                            />
                        </S.AppLink>
                    </S.AppsBlock>
                </S.feedbackContainer>
                <S.SectionContainer>
                    <S.Title>Покупателям</S.Title>
                    <S.NavItems>
                        <Link href="/condition/delivery" passHref legacyBehavior>
                            <S.NavItem>Условия доставки</S.NavItem>
                        </Link>
                        <Link href={'/condition/pickup'} passHref legacyBehavior>
                            <S.NavItem>Условия самовывоза</S.NavItem>
                        </Link>
                        <Link href="/company/loyalty" passHref legacyBehavior>
                            <S.NavItem>Программа лояльности</S.NavItem>
                        </Link>
                        <Link href={'/catalog/promotion/list'} passHref legacyBehavior>
                            <S.NavItem>Скидки и акции</S.NavItem>
                        </Link>
                    </S.NavItems>
                </S.SectionContainer>
                <S.SectionContainer>
                    <S.Title>Аптечная сеть</S.Title>
                    <S.NavItems>
                        <Link href={'/company/about'} passHref legacyBehavior>
                            <S.NavItem>О компании</S.NavItem>
                        </Link>
                        <S.NavItem data-stocks-show onClick={openStockSelectorWithBasketItems}>
                            Адреса аптек
                        </S.NavItem>
                        <Link href={'/company/vacancies'} passHref legacyBehavior>
                            <S.NavItem>Вакансии</S.NavItem>
                        </Link>
                    </S.NavItems>
                </S.SectionContainer>
                <S.SectionContainer>
                    <S.Title>Юридическая информация</S.Title>
                    <S.NavItems>
                        <Link href="/privacy-policy" passHref legacyBehavior>
                            <S.NavItem>Политика конфиденциальности</S.NavItem>
                        </Link>
                        <Link href="/terms-of-use" passHref legacyBehavior>
                            <S.NavItem>Пользовательское соглашение</S.NavItem>
                        </Link>
                    </S.NavItems>
                    <S.Title>Контакты</S.Title>
                    <S.NavItems>
                        <Link href={'/contact/feedback'} passHref legacyBehavior>
                            <S.NavItem>Обратная связь</S.NavItem>
                        </Link>
                    </S.NavItems>
                </S.SectionContainer>
            </S.NavBlock>
        </S.Footer>
    )
}

export default Footer
